import ScrollPage, {SectionItem} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import WankelStory from "../WenkleStory/WankleStory";
import ArazonaContent from "./ArazonaContent";
import TorontoContent from "./TorontoContent";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Toronto",        id: "toronto" }
];


const Toronto: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <TorontoContent />
    </Section>
  </ScrollPage>
);

export default Toronto;